import React, { useEffect, useState } from 'react';

interface ExamTimerProps {
    duration: number; // in minutes
    onTimeUp: () => void;
    isActive: boolean;
}

export const ExamTimer: React.FC<ExamTimerProps> = ({ duration, onTimeUp, isActive }) => {
    const [timeLeft, setTimeLeft] = useState(duration * 60);

    useEffect(() => {
        setTimeLeft(duration * 60);
    }, [duration]);

    useEffect(() => {
        if (!isActive || timeLeft <= 0) return;

        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    onTimeUp();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [isActive, timeLeft, onTimeUp]);

    const formatTime = (seconds: number) => {
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (hours > 0) {
            return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const isLowTime = timeLeft < 300; // Less than 5 minutes

    return (
        <div className={`font-mono text-xl font-bold rounded-lg px-4 py-2 flex items-center gap-2 shadow-sm transition-colors ${isLowTime ? 'bg-red-100 text-red-600 animate-pulse' : 'bg-blue-50 text-blue-700'
            }`}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {formatTime(timeLeft)}
        </div>
    );
};
